import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PartnerThemeContext } from ':core/context/partner-theme.context';
import { SentenceCasePipe } from ':shared/pipes';

@Component({
    selector: 'app-partner-header',
    templateUrl: './partner-header.component.html',
    styleUrl: './partner-header.component.scss',
    imports: [TranslateModule, SentenceCasePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerHeaderComponent {
    private readonly _partnerThemeContext = inject(PartnerThemeContext);

    readonly diagnosticDate = input<string>('');

    readonly activeTheme = this._partnerThemeContext.activeTheme;
}
